import { Box, Heading, Text } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../../ricos-context';

import { AI_MODAL_NO_SELECTION_CONTAINER } from '../../data-hooks';
import { NoSelectionIllustration } from './no-selection-illustration';
import styles from './no-selection-message-scss';

type NoSelectionMessageProps = {
  title?: string;
  text?: string;
};

export const NoSelectionMessage: React.FC<NoSelectionMessageProps> = ({ title, text }) => {
  const { t } = useContext(RicosContext);
  return (
    <Box
      dataHook={AI_MODAL_NO_SELECTION_CONTAINER}
      align="center"
      direction="horizontal"
      gap="SP7"
      paddingTop="SP6"
      paddingBottom="SP5"
      paddingLeft="SP5"
      paddingRight="SP5"
    >
      <Box flexShrink={0} align="center">
        <NoSelectionIllustration />
      </Box>
      <Box direction="vertical" verticalAlign="middle" flexGrow={1}>
        <Heading textAlign="center" size="medium">
          {t(title ?? 'AIPlugin_NoSelection_Title')}
        </Heading>
        <Text size="small" tagName="p" className={styles.paragraph}>
          {t(text ?? 'AIPlugin_NoSelection_Text')}
        </Text>
      </Box>
    </Box>
  );
};
